import { Record, Map } from 'immutable';
import {
  CLEAR_VALIDATION_ERRORS,
  SET_VALIDATION_ERRORS,
  SET_SOURCE_VISIBLE,
} from 'app/models/validations/constants';
import { parseValidationErrors } from 'app/models/validations/types';

export const ValidationErrors = Record({
  sources:       Map(), // source -> root-id -> [validations]
  sourceVisible: Map(), // source -> bool
}, 'ValidationErrors');

const initialState = () => ValidationErrors();

export const validationErrorsReducer = (state = initialState(), action) => {
  switch (action.type) {
    case CLEAR_VALIDATION_ERRORS: {
      return state.deleteIn(['sources', action.source, action.rootID]);
    }

    case SET_VALIDATION_ERRORS: {
      const errors = parseValidationErrors(action.errors);
      return state.setIn(['sources', action.source, action.rootID], errors);
    }

    case SET_SOURCE_VISIBLE: {
      return state.setIn(['sourceVisible', action.source], action.visible);
    }

    default:
      return state;
  }
};
